module.exports = __webpack_public_path__ + "static/fabric-persona-presence-bcfb764cd40fbbf44582c91f3bfa712d.png";